module.exports = __webpack_public_path__ + "media/assets/faria_products/CAM-ADV-06c6417c7d66eda3f886d0380764ab67bb617ed64f3118702f6202955530226f.svg";